import React from 'react';
import { VideoIcon, ScissorsIcon, BookOpenIcon, TrendingUpIcon, CheckCircleIcon } from 'lucide-react';
export function ContentSection() {
  return <section className="w-full bg-[#f5f5f5] py-10 md:py-16 px-4" data-id="element-55">
      <div className="max-w-5xl mx-auto" data-id="element-56">
        <div className="text-center mb-10 md:mb-14" data-id="element-57">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-58">
            La formación incluye
          </h2>
          <div className="w-20 md:w-32 h-1 bg-[#c41e3a] mx-auto" data-id="element-59"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-12" data-id="element-60">
          {/* Bloque 1 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-md border border-gray-200 flex flex-col md:flex-row gap-4 items-start hover:border-[#c41e3a]/50 transition-colors" data-id="element-61">
            <div className="bg-[#c41e3a]/10 p-3 rounded-lg flex-shrink-0" data-id="element-62">
              <VideoIcon className="w-8 h-8 text-[#c41e3a]" data-id="element-63" />
            </div>
            <div data-id="element-64">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-65">
                Clases en video paso a paso
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-66">
                Aprendé técnica real observando cada proceso con explicación
                clara.
              </p>
            </div>
          </div>

          {/* Bloque 2 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-md border border-gray-200 flex flex-col md:flex-row gap-4 items-start hover:border-[#c41e3a]/50 transition-colors" data-id="element-67">
            <div className="bg-[#c41e3a]/10 p-3 rounded-lg flex-shrink-0" data-id="element-68">
              <ScissorsIcon className="w-8 h-8 text-[#c41e3a]" data-id="element-69" />
            </div>
            <div data-id="element-70">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-71">
                Técnicas profesionales
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-72">
                Fade, degradados, precisión y estructura de corte.
              </p>
            </div>
          </div>

          {/* Bloque 3 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-md border border-gray-200 flex flex-col md:flex-row gap-4 items-start hover:border-[#c41e3a]/50 transition-colors" data-id="element-73">
            <div className="bg-[#c41e3a]/10 p-3 rounded-lg flex-shrink-0" data-id="element-74">
              <BookOpenIcon className="w-8 h-8 text-[#c41e3a]" data-id="element-75" />
            </div>
            <div data-id="element-76">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-77">
                Manual completo del método
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-78">
                Una guía técnica que acompaña cada etapa del aprendizaje.
              </p>
            </div>
          </div>

          {/* Bloque 4 */}
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-md border border-gray-200 flex flex-col md:flex-row gap-4 items-start hover:border-[#c41e3a]/50 transition-colors" data-id="element-79">
            <div className="bg-[#c41e3a]/10 p-3 rounded-lg flex-shrink-0" data-id="element-80">
              <TrendingUpIcon className="w-8 h-8 text-[#c41e3a]" data-id="element-81" />
            </div>
            <div data-id="element-82">
              <h3 className="text-xl font-black text-gray-900 mb-2" data-id="element-83">
                Profesionalización del oficio
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-84">
                Cómo convertir la habilidad en una fuente real de ingresos.
              </p>
            </div>
          </div>
        </div>

        {/* Bloque Para Quién Es */}
        <div className="bg-[#111] rounded-2xl p-6 md:p-10 shadow-xl max-w-3xl mx-auto mb-10" data-id="element-85">
          <h3 className="text-2xl font-black text-white mb-6 text-center" data-id="element-86">
            Esta formación es para:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-87">
            {['Personas que quieren aprender barbería desde cero', 'Quienes buscan un oficio real para generar ingresos', 'Barberos que quieren mejorar su técnica', 'Personas que quieren independencia laboral'].map(item => <div key={item} className="flex items-start gap-3 text-gray-300" data-id="element-88">
                <CheckCircleIcon className="w-5 h-5 text-[#c41e3a] flex-shrink-0 mt-0.5" data-id="element-89" />
                <span className="text-sm md:text-base font-semibold" data-id="element-90">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* CTA Repetido */}
        <div className="flex justify-center" data-id="element-91">
          <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-lg inline-block text-center shadow-xl" aria-label="Quiero ver la formación" data-id="element-92">
            👉 QUIERO VER LA FORMACIÓN
          </a>
        </div>
      </div>
    </section>;
}